import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Spinner, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const BildirimLoglari = () => {
  document.title = "Bildirim Logları | HarmanaGEL";

  const [loglar, setLoglar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLoglar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/BILDIRIM_LOGLARI?$top=500&$orderby=GONDERIM_TARIHI desc&$expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result && result.value) setLoglar(result.value);
    } catch (err) {
      setError("Bildirim logları yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLoglar();
  }, []);

  const okunduBadge = (okundu) => okundu ? <Badge color="success">Okundu</Badge> : <Badge color="warning">Okunmadı</Badge>;

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "Kullanıcı",
      accessorKey: "KULLANICILAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const u = cell.getValue();
        return u ? (
          <div>
            <div className="fw-medium">{u.AD_SOYAD}</div>
            <small className="text-muted">{u.Mail_Adress}</small>
          </div>
        ) : <span className="text-muted">Kullanıcı #{cell.row.original.KULLANICI_ID}</span>;
      },
    },
    {
      header: "Tip",
      accessorKey: "TIP",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => {
        const t = cell.getValue() || "SistemBildirim";
        // BildirimTipleri.cs ile uyumlu — mobil/web NotificationsScreen ile aynı kategoriler
        const colorMap = {
          YeniSiparis: "info", SiparisTeyit: "info", SiparisDurum: "info", SiparisIptalSatici: "info",
          SistemSiparisi: "info", KargoDurum: "info", YeniIade: "info", IadeTeyit: "info",
          IadeDurum: "info", IadeDurumSatici: "info", Finans: "info",
          YeniSoru: "success", SoruTeyit: "success", SoruCevaplandi: "success",
          SistemSorusu: "success", MagazaSoru: "success", MagazaSoruCevap: "success",
          IlanTeklif: "primary", TeklifCevap: "primary", TeklifTeyit: "primary",
          TeklifGuncellendi: "primary", TeklifRed: "primary", TeklifKazandi: "primary",
          MezatTeklif: "warning", CanliYayin: "warning",
          YeniDegerleme: "warning", DegerlemeTeyit: "warning", DegerlemeSonuc: "warning",
          DegerlemeSonucSahibi: "warning", DegerlemeTalepSahibi: "warning",
          YeniIlan: "primary", YeniYorum: "primary", YeniBegenme: "primary",
          FavoriEklendi: "primary", YeniTakipci: "primary", MagazaTakip: "primary",
          MagazaBasvuru: "info", MagazaDurumGuncelleme: "info",
          SistemBildirim: "secondary", YeniIcerik: "primary",
          // Legacy
          Bilgi: "info", Uyarı: "warning", Önemli: "danger", Promosyon: "success",
        };
        return <Badge color={colorMap[t] || "secondary"}>{t}</Badge>;
      },
    },
    {
      header: "Başlık",
      accessorKey: "BASLIK",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => <span className="fw-medium">{cell.getValue()}</span>,
    },
    {
      header: "İçerik",
      accessorKey: "ICERIK",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const text = cell.getValue() || "";
        return <span className="text-muted" style={{ maxWidth: 250, display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{text}</span>;
      },
    },
    {
      header: "İlgili ID",
      accessorKey: "ILGILI_ID",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => <span>#{cell.getValue() || "-"}</span>,
    },
    {
      header: "Okundu",
      accessorKey: "OKUNDU",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => okunduBadge(cell.getValue()),
    },
    {
      header: "Gönderim Tarihi",
      accessorKey: "GONDERIM_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleString("tr-TR") : "-";
      },
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Bildirim Logları" />

          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Bildirim Logları</h4>
                    <Button color="primary" size="sm" onClick={fetchLoglar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={loglar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Bildirim ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BildirimLoglari;
